import React from 'react';



export const DashboardIcon: React.FC<{ size?: number; className?: string }> = ({ size = 24, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
        <rect x="3" y="3" width="8" height="8" rx="2" fill="currentColor" opacity="0.9" />
        <rect x="13" y="3" width="8" height="8" rx="2" fill="currentColor" opacity="0.6" />
        <rect x="3" y="13" width="8" height="8" rx="2" fill="currentColor" opacity="0.6" />
        <rect x="13" y="13" width="8" height="8" rx="2" fill="currentColor" opacity="0.4" />
    </svg>
);

export const ChatsIcon: React.FC<{ size?: number; className?: string }> = ({ size = 24, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
        <path
            d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
            fill="currentColor"
            opacity="0.85"
        />
        <circle cx="8" cy="10" r="1.5" fill="white" />
        <circle cx="12" cy="10" r="1.5" fill="white" />
        <circle cx="16" cy="10" r="1.5" fill="white" />
    </svg>
);

export const ContactsIcon: React.FC<{ size?: number; className?: string }> = ({ size = 24, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
        <circle cx="12" cy="8" r="4" fill="currentColor" opacity="0.85" />
        <path
            d="M12 14C7.58 14 4 16.69 4 20V21C4 21.55 4.45 22 5 22H19C19.55 22 20 21.55 20 21V20C20 16.69 16.42 14 12 14Z"
            fill="currentColor"
            opacity="0.6"
        />
    </svg>
);

export const OperatorsIcon: React.FC<{ size?: number; className?: string }> = ({ size = 24, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
        <circle cx="9" cy="7" r="3.5" fill="currentColor" opacity="0.85" />
        <circle cx="15" cy="7" r="3.5" fill="currentColor" opacity="0.6" />
        <path
            d="M9 12C5.5 12 3 14.5 3 17.5V19H15V17.5C15 14.5 12.5 12 9 12Z"
            fill="currentColor"
            opacity="0.7"
        />
        <path
            d="M15 12C14 12 13.1 12.2 12.3 12.6C13.4 13.8 14 15.5 14 17.5V19H21V17.5C21 14.5 18.5 12 15 12Z"
            fill="currentColor"
            opacity="0.5"
        />
    </svg>
);

export const TelegramAccountIcon: React.FC<{ size?: number; className?: string }> = ({ size = 24, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
        <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
            fill="currentColor"
            opacity="0.15"
        />
        <path
            d="M9.78 17.5L10.06 14.09L15.74 8.97C15.99 8.75 15.69 8.64 15.36 8.83L8.33 13.25L5.09 12.21C4.4 12 4.39 11.53 5.25 11.17L17.04 6.55C17.62 6.3 18.16 6.68 17.93 7.55L15.9 17.5C15.74 18.25 15.28 18.43 14.64 18.08L11.36 15.69L9.78 17.22C9.78 17.22 9.62 17.37 9.78 17.5Z"
            fill="currentColor"
        />
    </svg>
);

export const ProxyIcon: React.FC<{ size?: number; className?: string }> = ({ size = 24, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
        <circle cx="5" cy="12" r="2.5" fill="currentColor" opacity="0.85" />
        <circle cx="12" cy="12" r="2.5" fill="currentColor" opacity="0.7" />
        <circle cx="19" cy="12" r="2.5" fill="currentColor" opacity="0.5" />
        <path d="M7.5 12H9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M14.5 12H16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M5 9V7C5 5.9 5.9 5 7 5H17C18.1 5 19 5.9 19 7V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M5 15V17C5 18.1 5.9 19 7 19H17C18.1 19 19 18.1 19 17V15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

export const SettingsIcon: React.FC<{ size?: number; className?: string }> = ({ size = 24, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
        <circle cx="12" cy="12" r="3" fill="currentColor" />
        <path
            d="M12 2L13.09 4.26L15.65 3.35L15.91 6.09L18.65 6.35L17.74 8.91L20 10L18.65 12L20 14L17.74 15.09L18.65 17.65L15.91 17.91L15.65 20.65L13.09 19.74L12 22L10.91 19.74L8.35 20.65L8.09 17.91L5.35 17.65L6.26 15.09L4 14L5.35 12L4 10L6.26 8.91L5.35 6.35L8.09 6.09L8.35 3.35L10.91 4.26L12 2Z"
            stroke="currentColor"
            strokeWidth="1.5"
            opacity="0.7"
            fill="none"
        />
    </svg>
);

export const SendIcon: React.FC<{ size?: number; className?: string }> = ({ size = 24, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
        <path
            d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z"
            fill="currentColor"
        />
    </svg>
);

export const CalendarIcon: React.FC<{ size?: number; className?: string }> = ({ size = 24, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
        <rect x="3" y="4" width="18" height="18" rx="2" fill="currentColor" opacity="0.2" />
        <rect x="3" y="4" width="18" height="6" rx="2" fill="currentColor" opacity="0.8" />
        <circle cx="7" cy="7" r="1" fill="white" />
        <circle cx="17" cy="7" r="1" fill="white" />
        <rect x="6" y="13" width="3" height="3" rx="0.5" fill="currentColor" opacity="0.6" />
        <rect x="10.5" y="13" width="3" height="3" rx="0.5" fill="currentColor" opacity="0.6" />
        <rect x="15" y="13" width="3" height="3" rx="0.5" fill="currentColor" opacity="0.6" />
        <rect x="6" y="17" width="3" height="3" rx="0.5" fill="currentColor" opacity="0.4" />
        <rect x="10.5" y="17" width="3" height="3" rx="0.5" fill="currentColor" opacity="0.4" />
    </svg>
);

export const TasksIcon: React.FC<{ size?: number; className?: string }> = ({ size = 24, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
        <rect x="3" y="3" width="18" height="18" rx="2" fill="currentColor" opacity="0.15" />
        <path d="M7 8L9 10L13 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="15" y="7" width="4" height="2" rx="1" fill="currentColor" opacity="0.6" />
        <path d="M7 13L9 15L13 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity="0.7" />
        <rect x="15" y="12" width="4" height="2" rx="1" fill="currentColor" opacity="0.4" />
        <rect x="7" y="17" width="6" height="2" rx="1" fill="currentColor" opacity="0.3" />
        <rect x="15" y="17" width="4" height="2" rx="1" fill="currentColor" opacity="0.3" />
    </svg>
);

export const ExportIcon: React.FC<{ size?: number; className?: string }> = ({ size = 24, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
        <rect x="3" y="3" width="18" height="18" rx="2" fill="currentColor" opacity="0.15" />
        <path d="M12 7L12 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M8 11L12 7L16 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 17H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export const StatAccountsIcon: React.FC<{ size?: number; className?: string }> = ({ size = 32, className }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className}>
        <defs>
            <linearGradient id="accountsGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#0088cc" />
                <stop offset="100%" stopColor="#00a8e8" />
            </linearGradient>
        </defs>
        <circle cx="16" cy="16" r="14" fill="url(#accountsGrad)" opacity="0.15" />
        <path
            d="M10.5 21L10.75 18L15.5 13.5C15.7 13.3 15.45 13.2 15.2 13.35L9.5 17L6.8 16.1C6.2 15.9 6.19 15.5 6.9 15.2L17 11.1C17.5 10.9 17.95 11.2 17.75 12L16 21C15.85 21.6 15.45 21.75 14.9 21.45L12.1 19.4L10.75 20.75C10.75 20.75 10.6 20.9 10.5 21Z"
            fill="url(#accountsGrad)"
        />
    </svg>
);

export const StatOperatorsIcon: React.FC<{ size?: number; className?: string }> = ({ size = 32, className }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className}>
        <defs>
            <linearGradient id="operatorsGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#8b5cf6" />
                <stop offset="100%" stopColor="#a855f7" />
            </linearGradient>
        </defs>
        <circle cx="16" cy="16" r="14" fill="url(#operatorsGrad)" opacity="0.15" />
        <circle cx="12" cy="12" r="3" fill="url(#operatorsGrad)" />
        <circle cx="20" cy="12" r="3" fill="url(#operatorsGrad)" opacity="0.7" />
        <path d="M12 16C9 16 7 18 7 21H17C17 18 15 16 12 16Z" fill="url(#operatorsGrad)" />
        <path d="M20 16C18.5 16 17.5 16.5 16.8 17.2C17.5 18.2 18 19.5 18 21H25C25 18 23 16 20 16Z" fill="url(#operatorsGrad)" opacity="0.7" />
    </svg>
);

export const StatMessagesIcon: React.FC<{ size?: number; className?: string }> = ({ size = 32, className }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className}>
        <defs>
            <linearGradient id="messagesGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#10b981" />
                <stop offset="100%" stopColor="#34d399" />
            </linearGradient>
        </defs>
        <circle cx="16" cy="16" r="14" fill="url(#messagesGrad)" opacity="0.15" />
        <path
            d="M24 8H8C6.9 8 6 8.9 6 10V24L10 20H24C25.1 20 26 19.1 26 18V10C26 8.9 25.1 8 24 8Z"
            fill="url(#messagesGrad)"
        />
        <circle cx="11" cy="14" r="1.5" fill="white" />
        <circle cx="16" cy="14" r="1.5" fill="white" />
        <circle cx="21" cy="14" r="1.5" fill="white" />
    </svg>
);

export const StatContactsIcon: React.FC<{ size?: number; className?: string }> = ({ size = 32, className }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className}>
        <defs>
            <linearGradient id="contactsGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#f59e0b" />
                <stop offset="100%" stopColor="#fbbf24" />
            </linearGradient>
        </defs>
        <circle cx="16" cy="16" r="14" fill="url(#contactsGrad)" opacity="0.15" />
        <circle cx="16" cy="11" r="4" fill="url(#contactsGrad)" />
        <path d="M16 17C11 17 8 20 8 24H24C24 20 21 17 16 17Z" fill="url(#contactsGrad)" />
    </svg>
);

export const StatisticsIcon: React.FC<{ size?: number; className?: string }> = ({ size = 24, className }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
        <rect x="3" y="12" width="4" height="9" rx="1" fill="currentColor" opacity="0.7" />
        <rect x="10" y="8" width="4" height="13" rx="1" fill="currentColor" opacity="0.85" />
        <rect x="17" y="3" width="4" height="18" rx="1" fill="currentColor" />
        <path d="M5 8L10 5L15 7L19 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.5" />
    </svg>
);

export default {
    DashboardIcon,
    ChatsIcon,
    ContactsIcon,
    OperatorsIcon,
    TelegramAccountIcon,
    ProxyIcon,
    SettingsIcon,
    SendIcon,
    CalendarIcon,
    TasksIcon,
    StatAccountsIcon,
    StatOperatorsIcon,
    StatMessagesIcon,
    StatContactsIcon,
    ExportIcon,
    StatisticsIcon,
};
